import React, { useEffect, useState } from "react";
import "./CardPortafolio.css";
import { VictoryPie } from "victory";
import { numFormatter } from "../../helpers/functions";
import { formatCurrencyCOP } from "../../helpers/FormatNumber";
import { INVERSIONES_USUARIO, TOTALES } from "../../constants/mockData";

export const ContentCard = () => {
  const [graphicDatas, setGraphicDatas] = useState([]);
  const [porcentajes, setPorcentajes] = useState([]);
  const [colors, setColors] = useState([]);

  // Paleta de colores
  const palette = [
    "#B9DE2C", "#00F5D4", "#557BD1", "#FFBA43", "#4D96FF",
    "#9B5DE5", "#F15BB5", "#00BBF9", "#00F5D4", "#FF924C"
  ];

  useEffect(() => {
    // 🔥 Usar datos centralizados
    const totalInvertido = TOTALES.total_invertido;

    const datos = INVERSIONES_USUARIO.map((item, index) => {
      const cop = Number(item.invested_amount || 0);
      const percent = totalInvertido > 0 ? (cop / totalInvertido) * 100 : 0;
      return {
        id: item.fondoInfo.id,
        name: item.fondoInfo.name,
        amount: cop,
        percent: percent.toFixed(2),
        units: item.unidades || 0,
        y: percent,
        x: `${percent.toFixed(2)}%`,
        color: item.fondoInfo.color || palette[index % palette.length]
      };
    });

    setGraphicDatas(datos.map((d) => ({ y: d.y, x: d.x, fill: d.color })));
    setPorcentajes(datos);
    setColors(datos.map((d) => d.color));
  }, []);

  const totalInvertido = TOTALES.total_invertido;
  const totalUnidades = TOTALES.total_unidades;

  return (
    <div className="contentCard" style={{ display: "block", padding: "0px" }}>
      <div className="row">
        <div className="col-md-6">
          <div style={{ maxHeight: "450px", display: "inline-grid", width: "100%" }} className="boxGrafico">
            <div className="title">
              <p className="h5">Mi portafolio</p>
            </div>
            <div className="graficoTwo" style={{ position: "relative", width: "100%", height: "380px" }}>
              <div className="p-label">
                <p className="body1">Total Invertido</p>
                <p className="h3">{formatCurrencyCOP(totalInvertido)}</p>
                <p className="body1">
                  Equivalen a {totalUnidades} unidades
                </p>
              </div>
              <VictoryPie
                data={graphicDatas}
                innerRadius={130}
                colorScale={colors}
                padding={{ top: 20, bottom: 20, left: 50, right: 50 }}
                labelRadius={({ innerRadius }) => innerRadius + 30}
                style={{
                  data: { fill: ({ datum }) => datum.fill },
                  labels: { 
                    fontSize: 16, 
                    fill: "#333",
                    fontWeight: "600"
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="boxInfoProyectos">
            {porcentajes.map((item) => (
              <div className="proyectoResidencial" key={item.id}>
                <div
                  className="indicador"
                  style={{ backgroundColor: item.color }}
                />
                <div className="info">
                  <div className="titleTwo">
                    <p className="caption">{item.name}</p>
                  </div>
                  <div className="titleTwo">
                    <p className="body2">{item.percent}%</p>
                    <p className="body2Bold">{numFormatter({ num: item.amount })}</p>
                  </div>
                  <div className="titleTwo">
                    <p className="caption">Total de Unidades</p>
                    <p className="captionBold">{item.units}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
